import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "dashboard-header"
}
const _hoisted_4 = {
  key: 0,
  class: "card"
}
const _hoisted_5 = { class: "info-wr" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row-value" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "row-value" }
const _hoisted_15 = { class: "controls" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "facade-gallery-wr" }
const _hoisted_18 = { class: "intenral-color-wr" }
const _hoisted_19 = { class: "intenral-color-wr" }
const _hoisted_20 = { class: "optional-upgrade-wr" }
const _hoisted_21 = { class: "filters" }
const _hoisted_22 = { class: "buttons" }
const _hoisted_23 = { class: "button default primary add-btn-primary bulk-btn" }
const _hoisted_24 = { class: "table-default" }
const _hoisted_25 = { class: "bold" }
const _hoisted_26 = { class: "center" }
const _hoisted_27 = { class: "center" }
const _hoisted_28 = { class: "actions" }
const _hoisted_29 = ["onClick", "src"]
const _hoisted_30 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($setup.builder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row-title" }, "Company name:", -1)),
                        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.builder.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row-title" }, "Email", -1)),
                        _createElementVNode("div", _hoisted_10, _toDisplayString($setup.builder.email || "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row-title" }, "Contact person:", -1)),
                        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.builder.contact || "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row-title" }, "Address", -1)),
                        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.builder.address || "-"), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      class: "button default edit",
                      onClick: $setup.onUpdateBuilder
                    }, "Edit Builder"),
                    _createElementVNode("button", {
                      class: "button button-with-icon",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isConfirmDeleteBuilderModalOpen = true))
                    }, [
                      _createElementVNode("img", {
                        src: require(`@/assets/icons/trash.svg`)
                      }, null, 8, _hoisted_16),
                      _cache[13] || (_cache[13] = _createElementVNode("span", null, "Delete Builder", -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createVNode($setup["AssetGallery"], {
                builderId: $setup.builderId,
                reload: $setup.reloadAssetGallery,
                title: "Facade",
                galleryType: $setup.AssetGalleryFormType.FACADE,
                fetchAssets: "facade/getFacadesByQuery",
                deleteAsset: "facade/deleteFacade",
                uploadImage: "facade/uploadImage",
                onSetReload: _cache[1] || (_cache[1] = ($event: any) => ($setup.reloadAssetGallery = false)),
                onUpdateAsset: $setup.updateAsset
              }, null, 8, ["builderId", "reload", "galleryType"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode($setup["AssetGallery"], {
                builderId: $setup.builderId,
                reload: $setup.reloadAssetGallery,
                title: "Internal Color Scheme",
                galleryType: $setup.AssetGalleryFormType.INTERNAL_COLOR_SCHEME,
                fetchAssets: "colorScheme/getColorSchemeByQuery",
                deleteAsset: "colorScheme/deleteColorScheme",
                uploadImage: "colorScheme/uploadImage",
                onSetReload: _cache[2] || (_cache[2] = ($event: any) => ($setup.reloadAssetGallery = false)),
                onUpdateAsset: $setup.updateAsset
              }, null, 8, ["builderId", "reload", "galleryType"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode($setup["AssetGallery"], {
                builderId: $setup.builderId,
                reload: $setup.reloadAssetGallery,
                title: "Inclusion",
                galleryType: $setup.AssetGalleryFormType.INCLUSION,
                fetchAssets: "inclusion/getInclusionsByQuery",
                deleteAsset: "inclusion/deleteInclusion",
                uploadImage: "inclusion/uploadImage",
                onSetReload: _cache[3] || (_cache[3] = ($event: any) => ($setup.reloadAssetGallery = false)),
                onUpdateAsset: $setup.updateAsset
              }, null, 8, ["builderId", "reload", "galleryType"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode($setup["AssetGallery"], {
                builderId: $setup.builderId,
                reload: $setup.reloadAssetGallery,
                title: "Optional Upgrade",
                galleryType: $setup.AssetGalleryFormType.OPTIONAL_UPGRADE,
                fetchAssets: "optionalUpgrade/getOptionalUpgradesByBuilderId",
                deleteAsset: "optionalUpgrade/deleteOptionalUpgrade",
                uploadImage: "optionalUpgrade/uploadImagesOptionalUpgrade",
                onSetReload: _cache[4] || (_cache[4] = ($event: any) => ($setup.reloadAssetGallery = false)),
                onUpdateAsset: $setup.updateAsset
              }, null, 8, ["builderId", "reload", "galleryType"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "title" }, "Home Designs", -1)),
              _createVNode($setup["InputSearch"], {
                class: "search-designs",
                modelValue: $setup.searchQuery,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.searchQuery) = $event)),
                placeholder: "Search",
                theme: "filter"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  class: "button default primary add-btn-primary",
                  onClick: $setup.onCreateHouse
                }, "Add House Design"),
                _createElementVNode("label", _hoisted_23, [
                  _cache[14] || (_cache[14] = _createTextVNode("Bulk Upload House Design", -1)),
                  _createElementVNode("input", {
                    class: "bulk-input",
                    type: "file",
                    onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.bulkUpload($event))),
                    accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  }, null, 32)
                ])
              ])
            ])
          ])),
      _createElementVNode("table", _hoisted_24, [
        _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "House Design"),
            _createElementVNode("th", { class: "center" }, "Bathrooms"),
            _createElementVNode("th", { class: "center" }, "Bedrooms"),
            _createElementVNode("th", null, "Price"),
            _createElementVNode("th", null, "Actions")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.houses, (house) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: house._id
            }, [
              _createElementVNode("td", _hoisted_25, _toDisplayString(house.name), 1),
              _createElementVNode("td", _hoisted_26, _toDisplayString(house.bathroom.quantity), 1),
              _createElementVNode("td", _hoisted_27, _toDisplayString(house.bedroom), 1),
              _createElementVNode("td", null, _toDisplayString($setup.getPrice(house)), 1),
              _createElementVNode("td", _hoisted_28, [
                _createElementVNode("img", {
                  onClick: ($event: any) => ($setup.onDeleteHouse(house)),
                  src: require(`@/assets/icons/trash.svg`)
                }, null, 8, _hoisted_29),
                _createElementVNode("img", {
                  class: "edit",
                  src: require(`@/assets/icons/edit.svg`),
                  onClick: ($event: any) => ($setup.onUpdateHouse(house._id))
                }, null, 8, _hoisted_30)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    ($setup.builder)
      ? (_openBlock(), _createBlock($setup["ConfirmDeleteModalVue"], {
          key: 0,
          isOpen: $setup.isConfirmDeleteBuilderModalOpen,
          deleteItem: `${$setup.builder.name} builder `,
          onConfirm: $setup.deleteBuilder,
          onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.isConfirmDeleteBuilderModalOpen = false))
        }, null, 8, ["isOpen", "deleteItem"]))
      : _createCommentVNode("", true),
    ($setup.houseToDelete)
      ? (_openBlock(), _createBlock($setup["ConfirmDeleteModalVue"], {
          key: 1,
          isOpen: $setup.isConfirmDeleteHouseModalOpen,
          deleteItem: `${$setup.houseToDelete.name} house design `,
          onConfirm: $setup.deleteHouse,
          onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.isConfirmDeleteHouseModalOpen = false))
        }, null, 8, ["isOpen", "deleteItem"]))
      : _createCommentVNode("", true)
  ], 64))
}